// extracted by mini-css-extract-plugin
module.exports = {"option":"option-_O96j","icon":"icon-kqaPF","label":"label-FEOiu"};